import React from 'react';
import PropTypes from 'prop-types';
import { ControlLabel } from 'react-bootstrap';
import { actions } from 'react-redux-form';
import { connect } from 'react-redux';
import ColorPickerField from './color-picker-field';

import './color-picker.css';

const defaultPickerColor = '#ffffff';
const colors = ['White', 'Black'];

class ColorPicker extends React.Component {
  state = {
    selectedColor: '',
    fieldColor: colors.includes(this.props.defaultColor) ? defaultPickerColor : this.props.defaultColor,
    fieldTextColor: colors
      .includes(this.props.defaultTextColor) ? defaultPickerColor : this.props.defaultTextColor,
  };

  handleChangeColor = (value) => {
    const { dispatch, model, textModel } = this.props;
    const { fieldColor, fieldTextColor } = this.state;

    if (value === 'Other') {
      this.setState({selectedColor: 'Other'});
      dispatch(actions.change(model, fieldColor));
      dispatch(actions.change(textModel, (fieldTextColor || defaultPickerColor)));
    } else {
      dispatch(actions.change(model, value));

      if (model !== textModel) {
        dispatch(actions.change(textModel, ''));
      }

      this.setState({selectedColor: value});
    }
  };

  handleChange = (color) => {
    const { dispatch, model } = this.props;

    this.setState({ fieldColor: color['Background colour'] });
    dispatch(actions.change(model, color['Background colour']));
  };

  handleTextChange = (color) => {
    const { dispatch, textModel } = this.props;

    this.setState({ fieldTextColor: color['Text colour'] });
    dispatch(actions.change(textModel, color['Text colour']));
  };

  render() {
    const {
      defaultColors, name, label, defaultColor, defaultTextColor, backgroundColorPicker
    } = this.props;
    const { selectedColor, fieldColor, fieldTextColor } = this.state;
    const checkedColor = selectedColor || defaultColor || defaultTextColor;
    const { handleChangeColor, handleChange, handleTextChange } = this;

    return (
      <div>
        <div>
          <ControlLabel>
            {label}
          </ControlLabel>
        </div>
        <div className="color-picker-flex-container">
          {Object.keys(defaultColors).map(color => (
            <div key={color} className="color-picker-option">
              <div className="color-picker-radio-button">
                <input
                  className="color-picker-radio"
                  type="radio"
                  key={color}
                  name={name}
                  value={defaultColors[color]}
                  onChange={() => handleChangeColor(color)}
                  checked={checkedColor === color}
                />
              </div>
              <div className="color-picker-label">
                {color}
              </div>
            </div>
          ))}
          <div className="color-picker-option">
            <div className="color-picker-radio-button">
              <input
                className="color-picker-radio"
                type="radio"
                key={'Other'}
                value={'Other'}
                onChange={() => handleChangeColor('Other')}
                checked={!colors.includes(checkedColor)}
              />
            </div>
            <div className="color-picker-label">
              Other
            </div>
          </div>
          {!colors.includes(checkedColor) && backgroundColorPicker && (
            <ColorPickerField
              label="Background colour"
              handleChange={handleChange}
              value={fieldColor || defaultPickerColor}
            />
          )}
          {!colors.includes(checkedColor) && (
            <ColorPickerField
              label="Text colour"
              handleChange={handleTextChange}
              value={fieldTextColor || defaultPickerColor}
            />
          )}
        </div>
      </div>
    );
  }
}

ColorPicker.propTypes = {
  model: PropTypes.string,
  textModel: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  textName: PropTypes.string,
  defaultColors: PropTypes.object.isRequired,
  defaultColor: PropTypes.string,
  defaultTextColor: PropTypes.string,
  backgroundColorPicker: PropTypes.bool
};

ColorPicker.defaultProps = {
  label: '',
  defaultColors: {
    White: '#ffffff', Black: '#000000'
  },
  backgroundColorPicker: true,
};

export default connect()(ColorPicker);



// WEBPACK FOOTER //
// ./src/components/common/form/elements/color-picker.jsx